import React, { FC, useState } from "react";
import { FormBaseType } from "@green0meter/api-client";

import FormBasicsDialog from "../FormBasicsDialog";

import { CardAction } from "@components/common";
import { Box, Card, Typography } from "@components/base";
import { useUserStore } from "@store/user";
import { useCreateForm } from "@api";

interface CollectDataActionProps {
  titleKey: string;
  descriptionKey: string;
  color?: string;
  icon?: string;
  buttonTextKey: string;
  noFormsTextKey: string;
  formBaseType?: FormBaseType;
}

const CollectDataAction: FC<CollectDataActionProps> = ({
  titleKey,
  descriptionKey,
  color = "teal",
  icon = "data-gathering",
  buttonTextKey,
  noFormsTextKey,
  formBaseType,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useUserStore();
  const { createFormEnabled } = useCreateForm(user);

  return createFormEnabled ? (
    <>
      <CardAction
        title={titleKey}
        text={<Typography variant="body2">{descriptionKey}</Typography>}
        color={color as CardAction["color"]}
        icon={icon as CardAction["icon"]}
        button={{
          text: buttonTextKey,
          onClick: () => setOpenDialog(true),
        }}
      />
      <FormBasicsDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        formBaseType={formBaseType}
      />
    </>
  ) : (
    <Card>
      <Box p={6}>
        <Typography textAlign="center" fontStyle="italic" color="text.secondary">
          {noFormsTextKey}
        </Typography>
      </Box>
    </Card>
  );
};

export default CollectDataAction;
